<template>
    <div>
        <!-- Customer Create Window  -->
        <window-create-customer
            ref="createCustomerWindow"
            :visible="windowCreateCustomerWindowVisible"
            @customer-created="onCustomerCreated"
            @closed="onWindowClosed"
        ></window-create-customer>

        <span class="form-group">
                  <kendo-dropdownlist ref="customerDropdownList"
                                      style="width: 80%"
                                      v-model="customerId"
                                      :data-items="customersDatasource"
                                      :text-field="'combinedName'"
                                      :value-field="'id'"
                                      :data-item-key="'id'"
                                      :value-primitive="true"
                                      :filterable="true"
                                      :default-item="placeholders.customerPlaceholderItem"
                                      :disabled="this.formdisabled"
                                      @change="onCustomerChange"
                                      @filterchange="onCustomerFilterChange"
                  >
                  </kendo-dropdownlist>
            <span v-if="!this.formdisabled" title="Neu anlegen" class="k-button" style="margin-left:5%; width: 10%; height: auto" @click="showCreateCustomerWindow">&nbsp;<i class="far fa-plus"></i>&nbsp;</span>
        </span>

    </div>
</template>

<script>
    import DOMPurify from 'dompurify';
    import { filterBy } from '@progress/kendo-data-query';

    export default {
        name: "customer-picker",
        props: ['presetcustomerid', 'formdisabled'],
        data: function () {
            return {
                dataAlreadySet: false,
                customersDatasource: [],
                customersDatasourceUnfiltered: [],
                windowCreateCustomerWindowVisible: false,
                placeholders:{
                    customerPlaceholderItem: {
                        combinedName: this.$t('general.please_choose')
                    },
                },
                /**
                 * Erweitert die Kontaktdaten um ein kombiniertes Feld für die Anzeige von Kunden
                 **/
                parseSchemaData: function(data) {
                    $.each(data.data, function (idx, elem) {
                        elem.combined_value = DOMPurify.sanitize(elem.id + ' ' + elem.first_name + ' ' + elem.last_name + ' ' + elem.email + ' ' + elem.company + ' ' + elem.city + ' ' + elem.zip);


                        // Korrekte Darstellung in der Kontaktwahl, falls die Firma nicht gesetzt ist
                        if (elem.company == null) {
                            elem.companyIfSet = "";
                        } else {
                            elem.companyIfSet = ",&nbsp;" + DOMPurify.sanitize(elem.company);
                        }

                        if (elem.first_name == null && elem.last_name == null) {
                            elem.userString = DOMPurify.sanitize(elem.email);
                        } else {
                            elem.userString = DOMPurify.sanitize(elem.first_name + " " + elem.last_name + " (" + elem.email + ")" + elem.companyIfSet);
                        }

                    });
                    return data;

                },

                customerIdNewCreated: null,
                customerId: this.presetcustomerid
            }
        },
        watch: {
            /**
             * Reagiert auf Änderungen der vordefinierten Customer ID und setzt das Feld neu
             * @param val Neuer Wert
             * @param oldVal Bisheriger Wert
             */
            presetcustomerid: function(val, oldVal){
                this.setPreselectedCustomer(val);
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.loadCustomerData();
            },

            loadCustomerData(){
                // Laden der Kunden und setzen eventuell gesetzter Preset IDs (neu anegelegte Kunden oder aus Vorauswahl)
                axios
                    .get('/api/customers/list')
                    .then(response => {
                        this.customersDatasource = response.data.data;
                        this.customersDatasourceUnfiltered = response.data.data;


                        if(this.presetcustomerid > 0){
                            console.log("preset customer id: ", this.presetcustomerid);
                            this.setPreselectedCustomer(this.presetcustomerid)
                        }

                        if(this.customerIdNewCreated > 0){
                            console.log("new created customer id: ", this.customerIdNewCreated);
                            this.setPreselectedCustomer(this.customerIdNewCreated)
                        }
                    });
            },


            /**
             * Setzt den aktuellen Kontakt anhand der übergebenen ID
             * @param customerId ID des zu setzenden Kontaktes
             */
            setPreselectedCustomer: function(customerId, force=false){
                console.log("set preselected customer");
                if(customerId){
                    if(!this.dataAlreadySet || force){
                        this.dataAlreadySet = true;
                        this.customerId = customerId;
                    }
                    this.customerId = customerId;
                    this.$emit('apply', this.customerId);
                }
            },

            /**
             * Wird ausgelöst, wenn der Kontakt geändert wird
             * @param e
             */
            onCustomerChange: function(e) {
                this.$emit('apply', this.customerId);
            },

            onCustomerFilterChange (e) {
                this.customersDatasource = filterBy(this.customersDatasourceUnfiltered.slice(), e.filter);
            },

            showCreateCustomerWindow: function(){
                this.windowCreateCustomerWindowVisible = true;
                let createCustomerWindow = this.$refs.createCustomerWindow;
            },

            onWindowClosed(){
                this.windowCreateCustomerWindowVisible = false;
            },

            /**
             * Wird ausgelöst, wenn ein neuer Kunde angelegt wurde
             */
            onCustomerCreated: function(e){
                console.log("Kunde wurde angelegt:", e);
                this.customerIdNewCreated = e;
                this.loadCustomerData();
            }
        }
    }
</script>

<style scoped>
</style>
